<template>
    <div>
        <seo-title :content="$t('index.meta.title')" />
        <seo-description :content="$t('index.meta.description')" />
        <seo-author content="Deveo ApS" />
        <seo-keywords content="webplatform, software, softwareudvikling, deveo, deveodk, deveo aps, vue, javascript, laravel, php, packages, open source" />
        <seo-og-title :content="$t('index.meta.title')" />
        <seo-og-description :content="$t('index.meta.description')" />
        <seo-og-image content="/static/images/opengraph/fb_og.png" />
        <section class="bg-deveo-gradient top-panel skew">
            <div class="container inside-skew">
                <div class="row">
                    <div class="col-lg-5 col-xs-12">
                        <h3 class="header">
                            {{ $t('index.mainHeader') }}<br>
                            <div class="index-typer">
                                {{ $t('index.firstService') }}
                            </div>
                        </h3>
                        <p class="breadtext">
                            {{ $t('index.mainText') }}
                        </p>
                        <router-link tag="a" :to="{name: 'Contact'}" href="#" class="btn btn-light btn-rounded">
                            {{ $t('index.mainContactButton') }}
                        </router-link>
                    </div>
                    <div class="col-lg-7 index-devices">
                        <div id="vw-device" class="device">
                            <img src="/static/images/landing/vw_new.svg" alt="Volkswagen"/>
                        </div>
                        <div id="quooker-device" class="device">
                            <img src="/static/images/landing/quooker-shop-vertical-landing.svg" alt="Quooker"/>
                        </div>
                        <div id="atea-device" class="device">
                            <img src="/static/images/landing/mobilswap-horizontal-landing.svg" alt="Mobilswap"/>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="bg-deveo-white" style="margin-top:-200px;padding-top:260px;">
            <div class="container">
                <div class="row">
                    <div class="col-lg-5 header-box" align="right">
                        <h3>
                            {{$t('index.subHeaderFirst')}}<br>
                            {{ $t('index.subHeaderSecond') }}
                        </h3>
                        <div class="icon">
                            <div class="outer">
                                <div class="inner">
                                    <span class="ion-ios-color-wand-outline"></span>
                                </div>
                            </div>
                        </div>
                        <p class="smaller">
                            {{ $t('index.subText') }}
                        </p>
                        <hr>
                        <router-link tag="a" :to="{name: 'Technology'}" href="#" class="simple-link">
                            {{ $t('index.subButton') }} <i class="ion-arrow-right-c"></i>
                        </router-link>
                        <br><br><br>
                        <br>
                        <br>
                        <br>
                    </div>
                </div>
            </div>
        </section>
        <section class="bg-deveo-light index-cases" style="margin-bottom:60px;position:relative;">
            <img src="/static/images/layout/bow.png" class="bow" alt="bow"/>
            <div class="container outer-cases-small">
                <h1>
                    {{ $t('index.casesHeader') }}
                </h1>
                <p class="fix-width">
                    {{ $t('index.casesText') }}
                </p>

                <div class="customer-wrapper row">
                    <div class="col-lg-6">
                        <div class="case quooker">
                            <img src="/static/images/customers/quooker.svg" alt="Quooker" />
                            <div class="casetext">
                                <b>"</b>
                                {{ $t('index.quookerStatement') }}
                                <b>"</b>
                            </div>
                            <p>
                                <b>Niclas Correll</b><br>
                                Quooker Skandinavien A/S
                            </p>
                        </div>
                        <div class="case half f2d">
                            <img src="/static/images/customers/f2d.png" alt="FRESH2DEATH" />
                        </div>
                        <div class="case half vw">
                            <img src="/static/images/customers/volkswagen_large.svg" alt="Volkswagen" />
                        </div>
                    </div>
                    <div class="col-lg-3">
                        <div class="case large semler">
                            <img src="/static/images/customers/semler.png" alt="Semler Retail A/S" />
                        </div>
                        <div class="case large julehjaelpen">
                            <img src="/static/images/customers/julehjaelpen.svg" alt="Julehjælpen" />
                        </div>
                    </div>
                    <div class="col-lg-3">
                        <div class="case prominds">
                            <img src="/static/images/customers/prominds.png" alt="Prominds" />
                        </div>
                        <div class="case large fclarsen">
                            <img src="/static/images/customers/fclarsen.png" alt="FC Larsen" />
                        </div>
                        <div class="case sepeeg">
                            <img src="/static/images/customers/sepeeg.png" alt="SEPEEG" />
                        </div>
                    </div>
                </div>

            </div>
        </section>
        <section class="index-iceberg">
            <img src="/static/images/layout/arch-bottom.svg" class="arch" alt="Arch">
            <div id="icebergwater"></div>
            <div class="titanic-container" :style="{left: titanic.x + 'px'}">
                <img src="/static/images/iceberg/titanic.svg" class="titanic" alt="Titanic" />
            </div>
            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-12 text-center">
                        <h3>{{ $t('index.icebergHeader') }}</h3>
                        <p>
                            {{ $t('index.icebergText') }}
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-7">
                        <div class="cloud-container">
                            <div class="cloud"></div>
                            <div class="cloud"></div>
                            <div class="cloud"></div>
                            <div class="cloud"></div>
                        </div>
                    </div>
                    <div class="col-lg-3">
                        <img src="/static/images/iceberg/main.svg" class="iceberg-main" alt="Iceberg" />
                    </div>
                </div>
            </div>
        </section>

        <section class="cta-section">
            <div class="container cta-container">
                <div class="row cta-background">
                    <div class="col-lg-6 index-contact-cta">
                        <h3>
                            {{ $t('index.ctaHeader') }}
                            <span>{{ $t('index.ctaSubheader') }}</span>
                        </h3>
                    </div>
                    <div class="col-lg-6">
                        <div class="cta-buttons">
                            <router-link tag="button" :to="{name: 'Contact'}" class="cta-button">
                                {{ $t('index.ctaFirstButton') }}
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
    export default {
        data () {
            return {
                locales: this.$i18n.messages,
                titanic: {
                    x: -400,
                    y: 220,
                    multiplier: 1
                },
                pressedKeys: {
                    left: false,
                    right: false,
                    up: false,
                    down: false
                },
                loop: null
            }
        },
        mounted () {
            window.addEventListener('keydown', this.detectKeyDown)
            window.addEventListener('keyup', this.detectKeyUp)
            this.gameLoop()
            this.pressedKeys.right = true
        },
        beforeDestroy () {
            window.removeEventListener('keydown', this.detectKeyDown)
            window.removeEventListener('keyup', this.detectKeyUp)
            clearInterval(this.loop)
        },
        methods: {
            gameLoop () {
                this.loop = setInterval(() => {
                    this.detectMove()
                }, 40)
            },
            detectKeyDown () {
                const pressedKeys = this.pressedKeys

                switch (event.key) {
                    case 'ArrowLeft':
                        pressedKeys.left = true
                        break
                    case 'ArrowRight':
                        pressedKeys.right = true
                        break
                }
            },
            detectKeyUp () {
                const pressedKeys = this.pressedKeys

                switch (event.key) {
                    case 'ArrowLeft':
                        pressedKeys.left = false
                        break
                    case 'ArrowRight':
                        pressedKeys.right = false
                        break
                }
            },
            detectMove () {
                const pressed = this.pressedKeys

                if (window.innerWidth - 300 < this.titanic.x) {
                    this.titanic.x = -300
                }

                if (pressed.left) {
                    this.moveTitanic(-1)
                }

                if (pressed.right) {
                    this.moveTitanic(1)
                }
            },
            moveTitanic (dx) {
                const titanic = this.titanic

                titanic.x += (dx || 0) * titanic.multiplier
            }
        }
    }
</script>
<style lang="scss">
    .outer-Index .d-footer{
        background: #3678da;
    }
    .navbar-light .navbar-toggler{
        display: none !important;
    }
</style>
<style lang="scss" scoped>
    .cta-section {
        background: #3678da;
    }
    .outer-Index .cta-buttons button {
        margin-top: 8px;
        background-color: #3678da;
        text-transform: none;
        width: 320px;
        padding: 15px;
    }
    .cta-container {
        margin-top: -100px;
        z-index: 9;
        position: absolute;
        left: 0;
        right: 0;
        max-width: 1100px;
    }
    @media screen and (max-width:992px){
        .cta-section{
            padding-bottom: 100px;
        }
        .cta-container {
        .index-contact-cta span{
            margin-top: 30px;
            margin-bottom: -10px;
        }
        margin-top: -250px;
        z-index: 9;
        position: absolute;
        left: 0;
        right: 0;
        max-width: calc(100% - 40px);
        .index-contact-cta {
            text-align: center;
        }
        .cta-button {
            width: 100% !important;
        }
    }
    }
    .index-contact-cta {
        h3, span {
            color: black;
        }
        h3 {
            font-weight: 500;
            font-size: 2rem;
        }
    }
    .cta-background {
        background-color: white;
        box-shadow: 0 18px 35px rgba(50, 50, 93, 0.1), 0 8px 15px rgba(0, 0, 0, 0.07);
        border-radius: 4px;
        text-align: left;
        padding: 30px 15px;
    }
    .bow{
        width: 100%;
        height: 60px;
        position: absolute;
        top: -60px;
    }

    #icebergwater{
        z-index: 3;
        position: absolute;
        bottom: 0;
        height: 400px;
        width: 100%;
        background: linear-gradient(rgba(30, 130, 255, 0.29), rgba(61, 106, 152, 0.28)), url(/static/images/iceberg/ocean_3.png);
        background-size: cover;
    }

    $gradientVolume: 5%;
    $quookerColor: #910d28;
    $semlerColor: #49545f;
    $promindsColor: #da2821;
    $julehjaelpenColor: #5CB85C;
    $fclarsenColor: #124A97;
    $sepeegColor: #EA662C;
    $vwColor: #0099da;
    $f2dColor: #000000;

    .customer-wrapper{

    }
    .case{
        height: 150px;
        background: #fff;
        border-radius: 4px;
        box-shadow: 0 18px 35px rgba(50, 50, 93, 0.1), 0 8px 15px rgba(0, 0, 0, 0.07);
        transition: 0.3s ease all;
        position: relative;
    }
    .case:not(.quooker){
        filter: grayscale(20%);
    }
    .case.large{
        height: 330px;
    }
    .case.half{
        width: calc(50% - 15px);
        float: left;
    }
    .case.half:last-of-type{
        margin-left: 30px;
    }
    .case:hover{
        transform: scale(1.01);
    }
    .case:not(.quooker) img,
    .case:not(.quooker) div{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        max-width: 70%;
        color: #fff;
    }
    .case.quooker{
        height: 510px;
        padding: 30px;
        text-align: left;
        background: $quookerColor;
        background: -webkit-linear-gradient(to bottom, rgba($quookerColor, 0.85) 15%, rgba($quookerColor, 0.85) 70%), url("/static/images/customers/quooker_bg.jpg") top;
        background: linear-gradient(to bottom, rgba($quookerColor, 0.85) 15%, rgba($quookerColor, 0.85) 70%), url("/static/images/customers/quooker_bg.jpg") top;
        background-size: cover;
        img{
            max-width: 50%;
            margin-bottom: 30px;
        }
        .casetext{
            font-weight: 200;
            color: #fff;
            font-size: 24px;
            position: absolute;
            top: calc(50% + 15px);
            transform: translate(0,-50%);
            width: calc(100% - 60px);
        }
        p{
            text-align: right;
            position: absolute;
            bottom: -30px;
            right: 30px;
            color: #fff;
        }
    }
    .case.quooker:hover *{
        cursor: default;
    }
    .case.semler{
        background: $semlerColor;
        background: -webkit-linear-gradient(to bottom, $semlerColor, lighten($semlerColor, $gradientVolume));
        background: linear-gradient(to bottom, $semlerColor, lighten($semlerColor, $gradientVolume));
    }
    .case.julehjaelpen{
        background: $julehjaelpenColor;
        background: -webkit-linear-gradient(to bottom, $julehjaelpenColor, lighten($julehjaelpenColor, $gradientVolume));
        background: linear-gradient(to bottom, $julehjaelpenColor, lighten($julehjaelpenColor, $gradientVolume));
    }
    .case.prominds{
        background: $promindsColor;
        background: -webkit-linear-gradient(to bottom, $promindsColor, lighten($promindsColor, $gradientVolume));
        background: linear-gradient(to bottom, $promindsColor, lighten($promindsColor, $gradientVolume));
    }
    .case.fclarsen{
        background: $fclarsenColor;
        background: -webkit-linear-gradient(to bottom, $fclarsenColor, lighten($fclarsenColor, $gradientVolume));
        background: linear-gradient(to bottom, $fclarsenColor, lighten($fclarsenColor, $gradientVolume));
    }
    .case.sepeeg{
        background: $sepeegColor;
        background: -webkit-linear-gradient(to bottom, $sepeegColor, lighten($sepeegColor, $gradientVolume));
        background: linear-gradient(to bottom, $sepeegColor, lighten($sepeegColor, $gradientVolume));
        img{
            max-width: 50%;
        }
    }
    .case.vw{
        background: $vwColor;
        background: -webkit-linear-gradient(to bottom, $vwColor, lighten($vwColor, $gradientVolume));
        background: linear-gradient(to bottom, $vwColor, lighten($vwColor, $gradientVolume));
    }
    .case.f2d{
        background: $f2dColor;
        background: -webkit-linear-gradient(to bottom, $f2dColor, lighten($f2dColor, $gradientVolume));
        background: linear-gradient(to bottom, $f2dColor, lighten($f2dColor, $gradientVolume));
        img{
            max-width: 50%;
        }
    }
    .case:nth-child(2),
    .case:nth-child(3){
        margin-top: 30px;
    }

    .customer-box {
        border-radius: 4px;
        padding: 10px;
        position: relative;
        box-shadow: 0 18px 35px rgba(50, 50, 93, 0.1), 0 8px 15px rgba(0, 0, 0, 0.07);
    .img-container {
            img {
                width: 200px;
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                margin: auto;
            }
        }
    }
    .customer-box:hover {
        /* transform: scale(1.01);
        box-shadow: 0 18px 35px rgba(50, 50, 93, 0.1), 0 8px 15px rgba(0, 0, 0, 0.07); */
    }
    @keyframes delay{
        0%{
            opacity: 0;
            transform: scale(1.5);
        }
        50%{
            transform: none
        }
        100%{
            opacity: 1;
            transform: none;
        }
    }
    .top-panel .header{
        font-weight: 300;
        font-size: 34px;
        line-height: 48px;
        color: #fff;
    }
    .top-panel .header b{
        font-weight: 700;
    }
    .top-panel p{
        margin: 30px 0;
        font-weight: 300;
        color: #d8ddf1;
        font-size: 15px;
    }
    .top-panel .btn:first-of-type{
        margin-right: 20px;
    }
    .index-typer{
        height: 48px;
        font-weight: 700;
    }
    .index-devices{
        transform: rotate(-8deg);
        margin-top: 30px;
    }
    .device{
        display: inline-block;
        position: absolute;
        transition: 0.3s ease all;
        border: 4px solid rgb(237,240,244);
        background: rgb(237,240,244);
        border-radius: 4px;
        box-shadow: inset 0 4px 7px 1px #fff, inset 0 -5px 20px rgba(173,186,204,.25), 0 2px 6px rgba(0,21,64,.14), 0 10px 20px rgba(0,21,64,.05);
    }
    .device:hover{
        transform: scale(1.02);
        // cursor: pointer;
    }
    #vw-device{
        width: 500px;
        top: 0;
        left: 65px;
        animation: delay 0.5s ease-in-out;
    }
    #quooker-device{
        width: 400px;
        left: 600px;
        animation: delay 1s ease-in-out;
    }
    #atea-device{
        width: 500px;
        left: 65px;
        top: 401px;
        animation: delay 0.75s ease-in-out;
    }
    .device img{
        width: 100%;
        // border-radius: 4px;
        // border: 4px solid rgb(237,240,244);
    }
    .lg-ref{
        padding: 60px;
    }
    .lg-ref b{
        display: block;
        margin: 20px 0;
    }
    .outer, .inner{
        height: 50px;
        width: 50px;
    }
    .inner span{
        display: block;
        height: 50px;
        line-height: 50px;
        text-align: center;
        color: #fff;
        font-size: 2em;
    }
    @media screen and (max-width:992px){
        .case{
            margin-top: 0px !important;
            margin-bottom: 30px;
        }
        .case:not(.quooker){
            height: 100px;
            width: calc(50% - 15px);
            float: left;
        }
        .case.julehjaelpen,
        .case.fclarsen{
            margin-left: 30px;
        }
        .case.sepeeg{
            display: none;
        }
        .index-cases{
            margin-bottom: 0px !important;
        }
        .big-buttons{
            padding-bottom: 0px;
        }
        .bg-deveo-white:last-of-type{
            padding-bottom: 120px;
            text-align: center;
            h3 span{
                margin-top: 20px;
            }
            .cta-buttons{
                text-align: center;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// index.vue?0396e935